/* eslint-disable no-magic-numbers */

const primary = {
	25: '#F5F9FF',
	50: '#E6EAF0',
	100: '#B8C4D5',
	200: '#8B9EB7',
	300: '#627897',
	400: '#3A5374',
	500: '#152E50',
	600: '#0D2648',
	700: '#061E3E',
	800: '#021733',
};

const neutral = {
	white: '#FFFFFF',
	50: '#F4F6F9',
	100: '#E2E7ED',
	200: '#D0D7E1',
	300: '#BFC8D3',
	400: '#AFB8C6',
	500: '#9FA9B7',
	600: '#8C97A7',
	700: '#798595',
};

const green = {
	25: '#E6FFF2',
	50: '#CCFFE5',
	75: '#A3FFCF',
	100: '#7AFFBA',
	200: '#52F8A5',
	300: '#34EA8F',
	400: '#1DD67A',
	500: '#13A75E',
	600: '#0B7741',
	700: '#054425',
};

const blue = {
	25: '#E3F2FF',
	50: '#CCEAFF',
	75: '#A3D8FF',
	100: '#7AC7FF',
	200: '#5AB7FF',
	300: '#42A6FF',
	400: '#2F95FF',
	500: '#2072C4',
	600: '#144F88',
	700: '#0A2D4D',
};

const red = {
	25: '#FFEEEF',
	50: '#FFD4D7',
	75: '#FFBCBF',
	100: '#FFA5AB',
	200: '#FD848C',
	300: '#F8656F',
	400: '#F14853',
	500: '#D53B45',
	600: '#B82F38',
	700: '#9A252C',
};

const redAlpha = {
	100: '#9c002380',
};

const orange = {
	25: '#FFF0E5',
	50: '#FFE2CC',
	75: '#FFCCA3',
	100: '#FFB781',
	200: '#FFA565',
	300: '#FF934E',
	400: '#FF833D',
	500: '#C4642B',
	600: '#88451C',
	700: '#4D260E',
};

export { primary, neutral, green, blue, red, orange, redAlpha };

export const primary25 = primary[25];
export const primary50 = primary[50];
export const primary100 = primary[100];
export const primary200 = primary[200];
export const primary300 = primary[300];
export const primary400 = primary[400];
export const primary500 = primary[500];
export const primary700 = primary[700];
export const primary800 = primary[800];

export const neutralWhite = neutral.white;
export const neutral50 = neutral[50];
export const neutral100 = neutral[100];
export const neutral200 = neutral[200];
export const neutral300 = neutral[300];
export const neutral400 = neutral[400];
export const neutral700 = neutral[700];
export const neutralBlack = '#000000';
export const neutralDisabled = '#9CA3AF';

export const green25 = green[25];
export const green400 = green[400];
export const green600 = green[600];

export const blue25 = blue[25];
export const blue50 = blue[50];
export const blue100 = blue[100];
export const blue200 = blue[200];
export const blue300 = blue[300];
export const blue400 = blue[400];
export const blue500 = blue[500];
export const blue600 = blue[600];
export const blue700 = blue[700];

export const red25 = red[25];
export const red50 = red[50];
export const red75 = red[75];
export const red100 = red[100];
export const red300 = red[300];
export const red400 = red[400];
export const red500 = red[500];
export const red600 = red[600];

export const redAlpha100 = redAlpha[100];

export const orange25 = orange[25];
export const orange500 = orange[500];
export const orangeRestricted = '#F79116';

// Grays
export const grayText = '#101214';
export const grayNearBlack = '#212121';
export const grayTextSecondary = '#596773';
export const grayBodyText = '#374151';
export const grayDark = '#1F2937';
export const grayMedium = '#6B7280';
export const grayBorderLight = '#D1D5DB';
export const grayBgSubtle = '#E3E8EF';
export const grayBlueMuted = '#D6DDE6';
export const graySlate = '#A6B5C9';
export const graySlateLight = '#CBD5E1';
export const graySlateXLight = '#94A3B8';
export const grayWarm = '#9A9F9F';
export const grayLightBg = '#F1F5F9';
export const grayLightBorder = '#E5E7EB';
export const grayXLightBg = '#ECEFF1';
export const grayScrollbar = '#c4c4c4';
export const grayScrollbarHover = '#a0a0a0';
export const grayRatingBorder = '#c8c8cc';
export const grayInputBorderAlt = '#e2e6ec';
export const grayUnselected = '#F6F6F7';

// Navy variants
export const navyDeepest = '#000518';
export const navyDeep = '#071835';
export const navyDark = '#1a2e52';
export const navyMedium = '#304770';
export const navyLight = '#48628E';
export const navyMuted = '#2d415a';
export const navySlate = '#738aab';
export const navyTeal = '#12424d';
export const navyNight = '#010D17';
export const navyDarkPanel = '#0F1E38';
export const navySlateDeep = '#0f172a';

// Blues
export const actionBlueDark = '#285AB8';
export const accentBlue = '#5C81E8';
export const themeBlueMain = '#426dd1';
export const themeBlueDark = '#2453AD';
export const ratingBlueSelected = '#126BDD';
export const ratingBlueHover = '#B4D1F9';
export const lightBlueBg = '#DFEFFF';
export const labelBlueBg = '#C4D8FF';
export const labelBlueText = '#003680';
export const labelInfoBg = '#014BAC';

// Status
export const statusSuccess = '#1EA672';
export const statusError = '#D33542';
export const statusWarning = '#F59E0B';
export const statusInfo = '#3B82F6';
export const statusNeutral = '#454F59';
export const statusSuccessIcon = '#00B252';
export const statusErrorIcon = '#FF0000';
export const statusWarningIcon = '#FF8A00';
export const statusInfoIcon = '#0066FF';
export const statusOverlay = '#48628E66';

// Label semantic
export const labelSuccessBg = '#D1ECD2';
export const labelSuccessText = '#214D23';
export const labelWarningBg = '#FFD68B';
export const labelWarningText = '#912300';
export const dangerLight = '#FFCEC9';
export const labelDangerText = '#7E0016';
export const labelWarningIconBg = '#C55400';
export const criticalRedBg = '#C80000';

// Greens / progress
export const successGreenAlt = '#12A34D';
export const successGreenDark = '#0D7C30';
export const progressSuccess = '#91D994';
export const progressDanger = '#B81C32';
export const errorTextAlt = '#b21d1d';
export const criticalRed = '#DC2626';
export const dangerLightAlpha = '#ffcec933';
export const successLight = '#78F5A5';
export const successLightAlpha = '#34ea8f33';
export const whiteAlpha30 = '#ffffff4d';
export const coinGoldBorder = '#FFDD4E';

// Medals / podium
export const medalGold = '#FFD700';
export const medalGoldMid = '#FFA500';
export const medalGoldDark = '#FF8C00';
export const medalSilver = '#C0C0C0';
export const medalSilverDark = '#111827';
export const bronzeMain = '#CD7F32';
export const bronzeLight = '#D97706';
export const bronzeDark = '#92400E';
export const bronzeMid = '#B45309';
export const redTierDark = '#6E0E1C';
export const redTierMid = '#8E1224';

// Alpha overlays
export const primary800Alpha75 = 'rgba(2, 23, 51, 0.75)';
export const primary800Alpha20 = 'rgba(2, 23, 51, 0.2)';
export const navyOverlay60 = 'rgba(9, 30, 66, 0.60)';
export const navyOverlay14 = 'rgba(9, 30, 66, 0.14)';
export const blackAlpha50 = 'rgba(0, 0, 0, 0.5)';
export const whiteAlpha65 = 'rgba(255, 255, 255, 0.65)';
export const grayBorderAlpha = 'rgba(227, 232, 239, 0.9)';
